export default "__VITE_ASSET__CbVliiQ___"